import { SET_FOCUSED_FIELD_PROPS, UNSET_PROPS, UPDATE_FOCUSED_VALUE } from '../actions/shortcuts';

const initialState = {
    id: null,
    shortcuts: null,
    value: null,
    changeHandler: null,
};

const shortcuts = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_FOCUSED_FIELD_PROPS:
            return {
                ...payload,
            };
        case UPDATE_FOCUSED_VALUE:
            return payload.id === state.id ? { ...state, ...payload } : { ...initialState };
        case UNSET_PROPS:
            return { ...initialState };
        default:
            return { ...state };
    }
};

export { shortcuts };
